module.exports = __webpack_public_path__ + "static/map-poster-319da66af65227419768a94bee542add.jpg";